module.exports = "//cdn.mxpnl.com/static/asset-cache/c4618f3310e3e56b7ca8903d5eb6a755/iron/common/assets/images/charts/cumulative-line.svg";